import type { Group } from "contexts/GroupsContext/GroupsContext";
import useSearchText from "providers/SearchTextProvider/useSearchText";
import useEntityTextSearch from "hooks/useEntityTextSearch";

const PROPERTIES_TO_SEARCH = ["name"] as Partial<keyof Group>[];

function useSearchGroups(groups: Group[]) {
  const searchText = useSearchText();
  return useEntityTextSearch<Group>(searchText, groups, PROPERTIES_TO_SEARCH);
}

export default useSearchGroups;
